import { createResource, JSX, Match, Switch } from "solid-js";
import { useTelescopeContext } from "@hubble/telescope";
import { goBack } from "~/shared_states/modal";
import { clientRepo } from "~/server/apis/client_repo";
import SolidMarkdown from "solid-markdown";
import { convertUrlsToLinks, rehypeUppercaseATags } from "~/utils/common";
import rehypeRaw from "rehype-raw";

export type TncsModalProps = {
  productId: string;
  headerText?: string;
};

export function TncsModal(props: TncsModalProps): JSX.Element {
  const { components } = useTelescopeContext();

  const [tncData] = createResource<string>(async () => {
    const tnc = await clientRepo.getVoucherProductTnc(props.productId);
    return tnc.content;
  });

  return (
    <div class=" flex flex-col">
      {/* Modal Header */}
      <div class="sticky top-0">
        <components.ModalHeader
          size="small"
          title={props.headerText || "Terms & Conditions"}
          onClose={() => {
            goBack();
          }}
        />
      </div>

      {/* Content */}
      <div class="px-5 py-5">
        <Switch>
          <Match when={tncData.state === "ready"}>
            <div class="tnc-list text-title-6-regular text-text-normal-primary">
              <SolidMarkdown
                rehypePlugins={[rehypeUppercaseATags, rehypeRaw] as any}
                children={convertUrlsToLinks(tncData()!)}
                linkTarget={"_blank"}
              />
            </div>
          </Match>
          <Match when={tncData.state === "pending"}>
            <div class="flex h-[400px] w-full items-center justify-center py-8">
              <components.Loader size="medium" />
            </div>
          </Match>
          <Match when={tncData.state === "errored"}>
            <div class="text-title-6-regular text-error-base">
              {tncData.error.message}
            </div>
          </Match>
        </Switch>
      </div>
    </div>
  );
}
